<template>
  <div class="rights-edit-container">
    <div class="page-header">
      <el-page-header @back="goBack" :content="isEdit ? '编辑权益' : '创建权益'"></el-page-header>
    </div>

    <el-card shadow="never" style="margin-top: 16px;">
      <el-form ref="goodsForm" :model="formData" :rules="formRules" label-width="120px" size="medium">
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="权益名称" prop="name">
              <el-input v-model="formData.name" placeholder="请输入权益名称" maxlength="200" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="权益描述" prop="description">
              <el-input v-model="formData.description" type="textarea" :autosize="{ minRows: 4, maxRows: 12 }" placeholder="请输入权益描述"></el-input>
            </el-form-item>
            <el-form-item label="兑换条件说明" prop="exchangeCondition">
              <el-input v-model="formData.exchangeCondition" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" placeholder="请输入兑换条件说明" maxlength="500"></el-input>
            </el-form-item>
            <el-form-item label="使用说明" prop="usageInstruction">
              <el-input v-model="formData.usageInstruction" type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" placeholder="请输入使用说明" maxlength="500"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="权益图标">
              <div class="icon-upload-area">
                <div class="icon-preview" v-if="formData.icon" @click="triggerIconUpload">
                  <el-image :src="resolveUrl(formData.icon)" fit="contain" style="width: 100%; height: 100%;"></el-image>
                  <div class="icon-overlay"><i class="el-icon-upload2"></i><span>更换图标</span></div>
                </div>
                <div class="icon-placeholder" v-else @click="triggerIconUpload">
                  <i class="el-icon-plus"></i><span>上传图标</span>
                </div>
                <input type="file" ref="iconInput" style="display: none" accept="image/*" @change="handleIconUpload" />
              </div>
            </el-form-item>
            <el-form-item label="权益类型" prop="rightsType">
              <el-select v-model="formData.rightsType" placeholder="请选择类型" style="width: 100%">
                <el-option v-for="item in rightsTypeOptions" :key="item.key" :label="item.name" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="兑换积分" prop="exchangePoints">
              <el-input-number v-model="formData.exchangePoints" :min="0" :max="999999" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="等级限制" prop="levelLimit">
              <el-select v-model="formData.levelLimit" placeholder="请选择等级限制" style="width: 100%">
                <el-option label="不限" :value="0"></el-option>
                <el-option label="VIP及以上" :value="2"></el-option>
                <el-option label="SVIP" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="库存数量" prop="stockQuantity">
              <el-input-number v-model="formData.stockQuantity" :min="-1" :max="999999" style="width: 100%"></el-input-number>
              <div style="font-size: 12px; color: #909399; margin-top: 4px;">-1表示不限库存</div>
            </el-form-item>
            <el-form-item label="每日兑换上限" prop="dailyExchangeLimit">
              <el-input-number v-model="formData.dailyExchangeLimit" :min="0" :max="9999" style="width: 100%"></el-input-number>
              <div style="font-size: 12px; color: #909399; margin-top: 4px;">0表示不限</div>
            </el-form-item>
            <el-form-item label="每人兑换限制" prop="perUserLimit">
              <el-input-number v-model="formData.perUserLimit" :min="0" :max="999" style="width: 100%"></el-input-number>
              <div style="font-size: 12px; color: #909399; margin-top: 4px;">0表示不限</div>
            </el-form-item>
            <el-form-item label="有效期">
              <el-date-picker
                v-model="validityRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                @change="handleValidityChange"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="是否支持退换" prop="supportRefund">
              <el-switch v-model="formData.supportRefund" :active-value="1" :inactive-value="0" active-text="支持" inactive-text="不支持"></el-switch>
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select v-model="formData.status" placeholder="请选择状态" style="width: 100%">
                <el-option label="草稿" value="DRAFT"></el-option>
                <el-option label="待审核" value="PENDING"></el-option>
                <el-option label="已上线" value="ONLINE"></el-option>
                <el-option label="已下线" value="OFFLINE"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序序号">
              <el-input-number v-model="formData.sortOrder" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="备注信息" maxlength="500"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="form-footer">
          <el-button @click="goBack">取消</el-button>
          <el-button type="info" @click="handleSaveDraft" :loading="submitLoading" v-if="hasPermission('activity:shop:save')">保存草稿</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getRightsGoodsDetail, createRightsGoods, updateRightsGoods, uploadRightsGoodsImage } from '@/apis/activity/rights'
import { getDictDataByType } from '@/apis/system/dict'
import { hasPermission } from '@/utils/permission'
import { getFullUrl } from '@/utils'

export default {
  name: 'RightsShopEdit',
  data() {
    return {
      isEdit: false,
      loading: false,
      submitLoading: false,
      validityRange: null,
      formData: {
        id: null,
        name: '',
        icon: '',
        rightsType: '',
        description: '',
        exchangePoints: 0,
        levelLimit: 0,
        validityStart: null,
        validityEnd: null,
        stockQuantity: -1,
        dailyExchangeLimit: 0,
        perUserLimit: 0,
        exchangeCondition: '',
        usageInstruction: '',
        supportRefund: 0,
        activityId: null,
        status: 'DRAFT',
        sortOrder: 0,
        remark: ''
      },
      formRules: {
        name: [{ required: true, message: '请输入权益名称', trigger: 'blur' }],
        rightsType: [{ required: true, message: '请选择权益类型', trigger: 'change' }],
        exchangePoints: [{ required: true, message: '请输入兑换积分', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      rightsTypeOptions: []
    }
  },
  created() {
    this.loadDictData()
    const id = this.$route.params.id
    if (id) {
      this.isEdit = true
      this.loadDetail(id)
    }
  },
  methods: {
    hasPermission,
    resolveUrl(url) {
      return getFullUrl(url)
    },
    loadDictData() {
      getDictDataByType('RIGHTS_TYPE').then(res => {
        this.rightsTypeOptions = res || []
      }).catch(e => {
        console.error('加载权益类型字典失败:', e)
        this.rightsTypeOptions = []
      })
    },
    goBack() {
      this.$router.push('/activity/shop')
    },
    loadDetail(id) {
      this.loading = true
      getRightsGoodsDetail(id).then(res => {
        if (res) {
          this.formData = { ...this.formData, ...res }
          if (res.validityStart && res.validityEnd) {
            this.validityRange = [res.validityStart, res.validityEnd]
          }
        }
      }).catch(e => {
        console.error('加载权益详情失败:', e)
      }).finally(() => {
        this.loading = false
      })
    },
    handleValidityChange(val) {
      if (val && val.length === 2) {
        this.formData.validityStart = val[0]
        this.formData.validityEnd = val[1]
      } else {
        this.formData.validityStart = null
        this.formData.validityEnd = null
      }
    },
    triggerIconUpload() {
      this.$refs.iconInput.click()
    },
    async handleIconUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      try {
        const fd = new FormData()
        fd.append('file', file)
        const res = await uploadRightsGoodsImage(fd)
        if (res) {
          this.formData.icon = res
          this.$message.success('图标上传成功')
        }
      } catch (err) {
        this.$message.error('图标上传失败')
      }
      e.target.value = ''
    },
    handleSaveDraft() {
      this.$refs.goodsForm.validate(valid => {
        if (!valid) return
        const data = { ...this.formData }
        data.status = 'DRAFT'
        this.submitLoading = true
        const action = this.isEdit ? updateRightsGoods(data) : createRightsGoods(data)
        action.then(() => {
          this.$message.success('保存草稿成功')
          this.goBack()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },
    handleSubmit() {
      this.$refs.goodsForm.validate(valid => {
        if (!valid) return
        const data = { ...this.formData }
        this.submitLoading = true
        const action = this.isEdit ? updateRightsGoods(data) : createRightsGoods(data)
        action.then(() => {
          this.$message.success(this.isEdit ? '更新成功' : '创建成功')
          this.goBack()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>

<style scoped>
.rights-edit-container {
  padding: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.icon-upload-area {
  width: 100%;
}

.icon-preview {
  width: 100%;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.icon-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s;
}

.icon-preview:hover .icon-overlay {
  opacity: 1;
}

.icon-placeholder {
  width: 100%;
  height: 120px;
  border: 2px dashed #dcdfe6;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  cursor: pointer;
  transition: border-color 0.3s;
}

.icon-placeholder:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.icon-placeholder i {
  font-size: 32px;
  margin-bottom: 8px;
}

.form-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}
</style>
